import { normalizeMsisdn } from 'utils/helpers';

export function onSubmit(data, authentication, updateContactsInfo, setIsModalOpen) {
  const { address, email, msisdn } = authentication;
  const hasEmailChanged = email !== data.email;
  const otpData = data.otp || null;
  const dataToSave = {
    address: {},
  };

  dataToSave.email = {
    email: email !== data.email ? data.email : email,
  };

  dataToSave.msisdn = {
    msisdn:
      msisdn !== normalizeMsisdn(data.msisdn)
        ? normalizeMsisdn(data.msisdn)
        : msisdn,
  };

  dataToSave.address.city = address.city !== data.city ? data.city : address.city;

  dataToSave.address.street = address.street !== data.street ? data.street : address.street;

  dataToSave.address.door = address.door !== data.door ? data.door : address.door;

  dataToSave.address.floor = address.floor !== data.floor ? data.floor : address.floor;

  dataToSave.address.province = address.province !== data.province
    ? data.province
    : address.province;

  dataToSave.address.postcode = address.postcode !== data.postcode
    ? data.postcode
    : address.postcode;

  updateContactsInfo(dataToSave, otpData, hasEmailChanged, setIsModalOpen);
}
